import { render, staticRenderFns } from "./IsResident.vue?vue&type=template&id=0497fb32"
import script from "./IsResident.vue?vue&type=script&lang=js"
export * from "./IsResident.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports